import { randomNumberGenerator } from "../../../helpers/common.functions";
import cloud from "../../../img/baseline-cloud_upload-24px.svg";
import PropTypes from "prop-types";
import "./DragDropUploadFile.css";

/// props validation | SQ(javascript:S6774)
DragDropUploadFile.propTypes = {
  setFile: PropTypes.func,
  setFilePreview: PropTypes.func,
  highlight: PropTypes.bool,
  setHighlight: PropTypes.func,
  setError: PropTypes.func,
  setMessages: PropTypes.func,
  inputKey: PropTypes.number,
  setInputKey: PropTypes.func,
  allowMultiple: PropTypes.bool,
};
export default function DragDropUploadFile(props) {
  const { setFile, setFilePreview } = props;
  const { highlight, setHighlight } = props;
  const { setError, setMessages } = props;
  const { inputKey, setInputKey } = props; // Change to reset the File Input
  const { allowMultiple } = props;

  let classType = "revamped-upload-button";
  if (highlight) {
    classType = "revamped-upload-button-highlight";
  }

  return (
    <label
      className={classType}
      id="file-upload-label"
      onDrop={(e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
          let newFiles = e.dataTransfer.files;
          setError({});
          setFile((files) => {
            return handleFiles(files, newFiles, allowMultiple);
          });
          if (allowMultiple) {
            setMessages([]);
            setFilePreview((files) => {
              return handleFiles(files, newFiles, allowMultiple);
            });
          }
        }
        setHighlight(false);
      }}
      onDragOver={(e) => {
        e.preventDefault();
        setHighlight(true);
      }}
      onDragLeave={(e) => {
        e.preventDefault();
        setHighlight(false);
      }}
    >
      <input
        key={inputKey}
        type="file"
        // Conditionally add the 'multiple' attribute
        {...(allowMultiple ? { multiple: true } : {})}
        className="input-file-upload-button"
        onChange={(e) => {
          e.preventDefault();
          setInputKey(randomNumberGenerator(0, 1).toString(36));
          if (e.target.files && e.target.files.length > 0) {
            let newFiles = e.target.files;

            setError({});
            setFile((files) => {
              return handleFiles(files, newFiles, allowMultiple);
            });
            if (allowMultiple) {
              setMessages([]);
              setFilePreview((files) => {
                return handleFiles(files, newFiles, allowMultiple);
              });
            }
          }
        }}
      />
      <div>
        <img alt="upload" className="upload-icon" src={cloud} />
        <div>{"Drag and drop files here"}</div>
        <span>{"OR"}</span>
        <div className="revamped-upload-button-browse">{"Browse"}</div>
      </div>
    </label>
  );
}

export function handleFiles(files, newFiles, allowMultiple) {
  if (!allowMultiple && files.length > 0) {
    // If not allowing multiple files, reset the files array
    files = [];
  }
  let oldFiles = [...files];
  for (let file of newFiles) {
    oldFiles.push(file);
  }
  return oldFiles;
}
